// Report status options for the chain editor dropdowns.
// Mirrors the backend eReportStatus enum values.
export const REPORT_STATUS_OPTIONS: { id: number; name: string }[] = [
  { id: 1, name: 'New' },
  { id: 2, name: 'Active' },
  { id: 3, name: 'Completed' },
  { id: 4, name: 'Merged' },
  { id: 5, name: 'Management' },
  { id: 6, name: 'Deleted' },
  { id: 7, name: 'Supplemented' },
];

export const reportStatusName = (id: number | null): string => {
  if (id === null || id === undefined) {
    return '';
  }
  const match = REPORT_STATUS_OPTIONS.find((o) => o.id === id);
  return match ? match.name : String(id);
};
